import classNames from "classnames";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHAT_ICON } from "../utils/svgs_new";
import IconWithBadge from "./IconWithBadge/IconWithBadge";

interface Props {
  badge: number;
  isPopperOpen: boolean;
  onClick: () => void;
}

const VisitChatIcon = (props: Props) => {
  return (
    <div className="VisitChatIcon">
      <IconWithBadge icon={CHAT_ICON} badge={props.badge} onClick={props.onClick} />
      <div className={classNames("__popper", { active: props.isPopperOpen })}>
        {translate(STRINGS.HAVE_A_QUESTION_LETS_CHAT)}
      </div>
    </div>
  );
};

export default VisitChatIcon;

export const useVisitChatIcon = () => {
  const [isPopperOpen, setPopperOpen] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => setPopperOpen(true), 10000);
    const timeout2 = setTimeout(() => setPopperOpen(false), 15000);

    return () => {
      clearTimeout(timeout);
      clearTimeout(timeout2);
    };
  }, []);

  return { state: { isPopperOpen: isPopperOpen } };
};
